import salesPalette from './salesOS';
import marketingPalette from './marketingOS';

export default {
  sales: {
    ...salesPalette,
  },
  marketing: {
    ...marketingPalette,
  },
};
